import useQueryParam from 'hooks/shared/useQueryParam';
import EventsMainContainer from 'presentation/containers/modules/event/EventsMainContainer';
import EventsByCategoryContainer from 'presentation/containers/modules/event/EventsByCategoryContainer';
import EventsPageLayout from 'presentation/layout/modules/events/EventsPageLayout';
import { FC } from 'react';

const EventListPage: FC = () => {
  const [categoryId] = useQueryParam<ID | null>('category', {
    ifAbsent: null,
    provider: (val) => +val,
  });

  const content = categoryId ? (
    <EventsByCategoryContainer categoryId={categoryId} />
  ) : (
    <EventsMainContainer />
  );

  return (
    <EventsPageLayout>
      {content}
    </EventsPageLayout>
  );
};

export default EventListPage;
